export default __webpack_public_path__ + "static/media/App_Store_Icon.1a1f8d73.svg";